<div class="digital-signature-cntr">
  <img alt="homepage" src="assets/companies/AXPOITALIA/logo.png" height="55" />
  <h2 class="title">Procedura di firma completata con successo</h2>
  <p class="description">Riceverai a breve un email con il documento firmato.</p>


</div>

